'use strict';

const User = require('../global/models/User');
const SV = require('server-vars');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const {
    URL: {
        queryKey,
        relative: PAGE
    }
} = require('bunsen/helpers/uri');
const FAVORITE_TRACKING = require('../components/FavoriteCta/trackingData');
const favoritePageActions = require('../global/actions/favoritePageActions');

let alreadyForced = false;

const forceFavorite = {
    QUERY_PARAM: 'follow',
    TYPE_SEARCH: 'search',
    TYPE_DEALER: 'dealer',
    TYPE_ITEM: 'item',

    /**
     * @param {String} payload.type                 type of favorite [search|dealer|item]
     * @param {Object} payload.heartEl              dom el of save button
     * @param {Boolean} payload.isFavorited
     */
    init(payload) {
        const {type, heartEl, actionContext} = payload;

        // new PDP calls this multiple times, need to make sure that we have all the data and execute it just once for visible view
        if (!this.isTypeForced(type) || alreadyForced || !actionContext && !heartEl) {
            return;
        }

        User.handleEmailToken().always(() => this._forceFavorite(payload));

        alreadyForced = true;
    },

    /**
     * Checks if query param to enforce follow type is there
     *
     * @param {String} type     type of favorite [search|dealer|item]
     * @return {Boolean}
     */
    isTypeForced(type) {
        return queryKey[this.QUERY_PARAM] === type;
    },

    /**
     * @param {String} payload.type             type of favorite [search|dealer|item]
     * @param {Object} payload.saveButtonView   Backbone.view of save button
     * @param {Object} payload.saveWidgetView   Backbone.view of save widget
     * @private
     */
    _forceFavorite(payload) {
        const {type, heartEl, isFavorited, actionContext} = payload;

        switch (type) {
            case this.TYPE_SEARCH:
                actionContext.dispatch('favoritePage:forceSuccess', {
                    type: FavoriteModel.TYPE_SEARCH,
                    value: true
                });
                actionContext.executeAction(favoritePageActions.saveToFavorites, {
                    solrQuery: SV.get('data.sq'),
                    page: PAGE,
                    type: FavoriteModel.TYPE_SEARCH,
                    tracking: FAVORITE_TRACKING.SEARCH.TOP_OF_RESULTS.save,
                    authModalOptions: FAVORITE_TRACKING.SEARCH.BROWSE_AUTH_MODAL
                }).then(() => {
                    actionContext.dispatch('favoritePage:forceSuccess', {
                        type: FavoriteModel.TYPE_SEARCH,
                        value: false
                    });
                });
                break;

            case this.TYPE_DEALER:
                actionContext.executeAction(favoritePageActions.saveToFavorites, {
                    primaryKey: SV.get('data.seller.pk'),
                    type: FavoriteModel.TYPE_DEALER,
                    tracking: FAVORITE_TRACKING.DEALER.SELLERS_PAGE.save,
                    authModalOptions: FAVORITE_TRACKING.DEALER.DEALER_STOREFRONT_AUTH_MODAL
                });
                break;

            case this.TYPE_ITEM:
                if (!User.loggedIn() || !isFavorited) {
                    this._triggerViewClick(heartEl);
                }
                break;
        }
    },

    /**
     * @param {Object} heartEl   dom node of save button
     * @private
     */
    _triggerViewClick(heartEl) {
        heartEl.click();
    }
};

module.exports = forceFavorite;



// WEBPACK FOOTER //
// ./assets/js/favorites/forceFavorite.es.js